import { lazy } from 'react'
import BasicLayout from '../components/layout/BasicLayout'
import routerConstants from '../constants/routerConstants'

const routeKhoVatLy: any[] = [
  {
    path: routerConstants.khoVatLy.list,
    name: 'khoVatLyList',
    exact: true,
    layout: BasicLayout,
    component: lazy(() => import('../components/admin/khoVatLys/KhoVatLyList')),
  },
]

export { routeKhoVatLy }
